export default "__VITE_ASSET__b_HBkZNk__"